<template>
  <div class="toolbar-container">
    <v-toolbar flat class="custom-toolbar">
      <!-- Logo Section -->
      <div class="logo-container">
        <img v-if="logo" :src="logo" alt="Logo" class="toolbar-logo" />
        <span v-else class="toolbar-title">{{ title }}</span>
      </div>
      <v-spacer></v-spacer>
      <v-btn
        v-if="showExportButton"
        @click="onExportClick"
        class="export-btn"
        color="#ededed"
      >
        Export
      </v-btn>
      <v-select
        v-if="showSelect"
        v-model="internalSelectedColumn"
        :items="columnOptions"
        item-value="value"
        item-text="text"
        label="Search By"
        class="column-select"
      ></v-select>
      <v-select
        v-if="showSearch && ['category_name', 'provider_name'].includes(internalSelectedColumn)"
        v-model="internalSearch"
        :items="dropdownOptions"
        label="Search"
        class="search-field"
        append-icon="mdi-magnify"
        hide-details
        single-line
      ></v-select>
      <v-text-field
        v-if="showSearch && !['category_name', 'provider_name'].includes(internalSelectedColumn)"
        v-model="internalSearch"
        label="Search"
        class="search-field"
        append-icon="mdi-magnify"
        hide-details
        single-line
      ></v-text-field>
    </v-toolbar>
  </div>
</template>



<script>
import store from '../store'; // Import Vuex store

export default {
  props: {
    logo: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    search: {
      type: String,
      default: ''
    },
    selectedColumn: {
      type: String,
      default: ''
    },
    columnOptions: {
      type: Array,
      default: () => []
    },
    showExportButton: {
      type: Boolean,
      default: true
    },
    showSelect: {
      type: Boolean,
      default: true
    },
    showSearch: {
      type: Boolean,
      default: true
    },
    exportToExcel: {
      type: Function,
      default: () => {}
    },
    items: {
      type: Array,
      default: () => []
    },
    categories: {
      type: Array,
      default: () => []
    },
    providers: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      internalSearch: this.search,
      internalSelectedColumn: this.selectedColumn,
      dropdownOptions: [], // Data to store dropdown options
      user: store.getters.auth
    };
  },
  watch: {
    search(newVal) {
      this.internalSearch = newVal;
      this.$nextTick(() => {
        if (this.$refs.searchField) {
          this.$refs.searchField.focus(); // Focus after DOM update
        } else {
          console.warn('searchField ref is not defined');
        }
      });
    },
    selectedColumn(newVal) {
      this.internalSelectedColumn = newVal;
      this.internalSearch = '';
      this.updateDropdownOptions(); // Update dropdown options whenever the column changes
    },
    internalSearch(newVal) {
      this.$emit('update:search', newVal);
    },
    internalSelectedColumn(newVal) {
      this.internalSearch = '';
      this.$emit('update:selectedColumn', newVal);
      this.updateDropdownOptions(); // Update dropdown options whenever the internal selected column changes
    }
  },
  methods: {
    onExportClick() {
      if (this.exportToExcel) {
        this.exportToExcel();
      }
    },
    updateDropdownOptions() {
      if (this.internalSelectedColumn === 'category_name') {
        this.dropdownOptions = this.categories;
      } else if (this.internalSelectedColumn === 'provider_name') {
        this.dropdownOptions = this.providers;
      } else {
        this.dropdownOptions = [];
      }
    }
  },
  mounted() {
    this.updateDropdownOptions(); // Initialize dropdown options when the component is mounted
  }
}
</script>

<style scoped>
.toolbar-logo {
  margin-bottom: 35px;
}

.export-btn {
  margin-right: 50px;
  margin-bottom: 26px;
}

.column-select {
  margin-right: 16px;
  max-width: 20%;
  height: 56px; /* Ensures consistent height with input fields */
}

.search-field {
  width: 250px;
  margin-left: 16px;
  height: 56px; /* Ensures consistent height with select fields */
}

.toolbar-container {
  display: flex;
  align-items: center; /* Vertically align items */
}

.logo-container {
  display: flex;
  align-items: center;
}

.toolbar-logo {
  height: 40px; /* Adjust the size as needed */
  width: auto;
  margin-right: 10px;
}

.toolbar-container h1 {
  margin: 0;
}

.toolbar-title {
  font-size: 24px;
  font-weight: 500;
}
</style>

